import { render, staticRenderFns } from "./ProductDetailDrawings.vue?vue&type=template&id=df404d80&scoped=true"
import script from "./ProductDetailDrawings.vue?vue&type=script&lang=js"
export * from "./ProductDetailDrawings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df404d80",
  null
  
)

export default component.exports